import ListWithHeader from '../modules/CardListWithHeader';
import SmallCopyBlock from '../blocks/SmallCopy'
import FooterEngagement from '../modules/CardFooterEngagement';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function Footer(){
    return (
        <> 
            <Row className='brand-primary-color'>
                <Col>
                    <ListWithHeader  title="Sunset Liquor" items={[]}/>
                </Col>
                <Col md={{span: 3}}>
                    <FooterEngagement />
                </Col>
            </Row>
            <Row className='brand-tertiary-color'>
                <Col>
                    <SmallCopyBlock styling='text-light'>All rights reserved (C) Sunset Liquor</SmallCopyBlock>
                </Col>
                <Col>
                    <SmallCopyBlock styling='text-light'>Designed By: <a href="https://bigdistanceenergy.com">Big Distance Energy Creative</a></SmallCopyBlock>
                </Col>
                <Col>
                    <SmallCopyBlock styling='text-light'>Sunset RSS Feed</SmallCopyBlock>
                </Col>
            </Row>
            <Row className='brand-tertiary-color'>
                <Col>
                    <SmallCopyBlock styling='text-light'><a href="/privacy">Privacy Policy</a></SmallCopyBlock>
                </Col>
                <Col>
                    <SmallCopyBlock styling='text-light'><a href="/accessibility">Accessibilty Policy</a></SmallCopyBlock>
                </Col>
                <Col>
                    <SmallCopyBlock styling='text-light'>SMS Terms & Privacy</SmallCopyBlock>
                </Col>
            </Row>
        </>
    )
}

export default Footer;